export enum SpacePricingEnum {
  PER_PERSON = 'per_person',
  PER_GRANULARITY = 'per_granularity',
}
